<script>
	import { onMount } from 'svelte';
	import { replace, push } from 'svelte-spa-router';
	import TBox from './templates/TBox.svelte';

	let projetos, relatorios, avaliacoes, apresentacoes, downloadCertificado, informacosAPICache;

	onMount( async () => {
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));

		if (informacosAPICache == undefined)
			replace("/");
		else {
			let { prazos } = informacosAPICache;
		
			projetos = `de ${prazos.cadastro_projetos_inicio} até ${prazos.cadastro_projetos_fim}`;
			relatorios = `de ${prazos.cadastro_relatorios_projeto_inicio} até ${prazos.cadastro_relatorios_projeto_fim}`;
			avaliacoes = `de ${prazos.avaliacao_inicio} até ${prazos.avaliacao_fim}`;
			apresentacoes = `de ${prazos.cadastro_apresentacoes_projeto_inicio} até ${prazos.cadastro_apresentacoes_projeto_fim}`;
			downloadCertificado = `de ${prazos.download_cert_participacao_inicio} até ${prazos.download_cert_participacao_fim}`;
		}
	});

	const verificarProrrogacoes = () => push(`/limpeza-aplicacao/${Math.random()}?m=${window.btoa(unescape(encodeURIComponent("Redirecionando, aguarde e retorne ...")))}`);
</script>

<TBox 
	titulo="Prazos" 
	subtitulo="Veja os prazos abaixo" 
	largura="6" 
	deslocamento="3" 
	icone="calendario">

	<small>Prazos de utilização do sistema. Para demais prazos, consulte a ordem de serviço.</small>

	<hr>

	<p>Cadastro e alteração de projetos: </p>
	<strong>{ projetos ?? 'consultando...' }</strong>
	
	<br><br>

	<p>Cadastro e alteração de relatórios de projeto: </p>
	<strong>{ relatorios ?? 'consultando...' }</strong>

	<br><br>
	<p>Inscrição de apresentações dos projetos: </p>
	<strong>{ apresentacoes ?? 'consultando...' }</strong>

	<br><br>
	<p>Avaliação de projetos / apresentações: </p>
	<strong>{ avaliacoes ?? 'consultando...' }</strong>

	<br><br>
	<p>Download do Certificado de Partipação SDG: </p>
	<strong>{ downloadCertificado ?? 'consultando...' }</strong>

	<div class="has-text-centered mt-5">
		<a href="#/" class="button is-dark is-medium is-outlined">Início</a>
		<button on:click={verificarProrrogacoes} class="button is-success is-medium">Verificar prorrogações</button>
	</div>
</TBox>